import Vue from 'vue';

import auth from './auth';
import ui from './ui';
import helpers from './helpers';
import dynContentTemplates from './dyncontent-templates';
//import dynContents from './dyn-contents';

Vue.mixin(auth);
Vue.mixin(ui);
Vue.mixin(helpers);
Vue.mixin(dynContentTemplates);
//Vue.mixin(dynContents);


// WEBPACK FOOTER //
// ./src/mixins/index.js